import {
  FILTERS_RESET,
  LAYOVER_AIRPORT_FILTER_CHANGED,
  LAYOVER_AIRPORTS_CLEAR_ALL,
  LAYOVER_AIRPORTS_SELECT_ALL,
  LAYOVER_DURATION_FILTER_CHANGED,
} from '../../../../../../actions/filters';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { LayoversFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/layovers';

export const INITIAL_STATE: LayoversFilterState = {
  duration: {
    min: null,
    max: null,
  },
  excludedAirports: [],
};

export const createLayoversReducer =
  (getInitialState: () => LayoversFilterState = () => INITIAL_STATE) =>
  (state: LayoversFilterState = getInitialState(), action: Action): LayoversFilterState => {
    switch (action.type) {
      case LAYOVER_DURATION_FILTER_CHANGED: {
        return {
          ...state,
          duration: {
            min: action.payload.min,
            max: action.payload.max,
          },
        };
      }

      case LAYOVER_AIRPORT_FILTER_CHANGED: {
        const { excluded, placeEntityId } = action.payload;
        const currentExcluded = state.excludedAirports;

        if (excluded && !currentExcluded.includes(placeEntityId)) {
          return {
            ...state,
            excludedAirports: [...currentExcluded, placeEntityId],
          };
        }

        if (!excluded && currentExcluded.includes(placeEntityId)) {
          return {
            ...state,
            excludedAirports: currentExcluded.filter((code) => code !== placeEntityId),
          };
        }

        return state;
      }

      case LAYOVER_AIRPORTS_SELECT_ALL: {
        return {
          ...state,
          excludedAirports: [],
        };
      }

      case LAYOVER_AIRPORTS_CLEAR_ALL: {
        return {
          ...state,
          excludedAirports: action.payload.placeEntityIds,
        };
      }

      case FILTERS_RESET: {
        return INITIAL_STATE;
      }

      default:
        return state;
    }
  };

const layoversReducer = createLayoversReducer();
export default layoversReducer;

export const getDuration = (state: LayoversFilterState) => state.duration;
export const getExcludedAirports = (state: LayoversFilterState) => state.excludedAirports;
